import type { ValueFormatterParams } from 'ag-grid-community';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';

/** Column that takes a FixingIndex.Name and renders DisplayName when available. */
export const fixingIndex: ColDefFactory<Column> = column => ({
  ...baseColumn(column),
  valueFormatter: ({ value, context }: ValueFormatterParams<unknown, any>) => {
    if (!value) {
      return '';
    }
    if (typeof value !== 'string') {
      return value;
    }

    return context.current.fixingIndicesByName?.get(value)?.DisplayName || value;
  },
});
